const swiper = new Swiper('.hero-slider--swiper', {
    slidesPerView: 1,
    loop: true,
    effect: "fade",
    speed: 900,   // transition animation speed in ms
    autoplay: {
        delay: 3200,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    }
});
